import {Features} from '@app/shared/models/features';

export class DatasourceSettings {

  public constructor( public features: Features[], public allVisiblePaths?: string[] ) {

  }

}
